import React from "react";
import { Search } from "lucide-react";

const SearchBar = ({ searchTerm, setSearchTerm, onFocus, onBlur }) => (
  <div className="relative w-full">
    <input
      type="text"
      placeholder="Search by provider name or city..."
      className="w-full px-4 py-3 rounded-xl border border-slate-300 focus:border-brand-500 
                 shadow-lg focus:shadow-xl outline-none transition-all duration-300
                 pl-14 text-lg"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
    />
    <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
  </div>
);

export default SearchBar;
